import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box as Wrapper } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'

const Description = () => {
  const { t } = useTranslation()

  return (
    <Wrapper paddingB={16}>
      <p className="text-center mb-5 text-body-regular text-foreground-subdued">
        {t('twoFactorVerification.descriptionPartOne')}
        <ExternalLink href={process.env.AUTHY_DOWNLOAD_LINK}>
          {t('twoFactorVerification.authy')}
        </ExternalLink>
        ,{' '}
        <ExternalLink href={process.env.GOOGLE_AUTH_DOWNLOAD_LINK}>
          {t('twoFactorVerification.googleAuthenticator')}
        </ExternalLink>
        ,{' '}
        <ExternalLink href={process.env.MICROSFT_AUTH_DOWNLOAD_LINK}>
          {t('twoFactorVerification.microsoftAuthenticator')}
        </ExternalLink>
        , {t('twoFactorVerification.etc')}.
      </p>
      <p className="text-center text-body-regular text-foreground-subdued">
        {t('twoFactorVerification.descriptionPartTwo')}{' '}
        <ExternalLink href={process.env.TWO_FACTOR_LEARN_MORE_LINK}>{t('learnMore')}</ExternalLink>
      </p>
    </Wrapper>
  )
}

export default React.memo(Description)
